// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crm-title {
  position: relative;
  display: inline-block;
  align-self: center;
  margin: 0;
}

.customer .list-group-item.active {
  background-color: #e3b5bb !important;
  border-color: #e3b5bb !important;
  color: white !important;
}

.customer_row .row {
  border-bottom: #ddd solid 1px;
}
.customer_row .row:last-child {
  border-bottom: none;
}
.customer_row .nav-tabs .nav-link,
.customer_row .nav-item.show .nav-link {
  color: #e3b5bb !important;
  border-color: #e3b5bb !important;
}
.customer_row .nav-tabs .nav-link.active,
.customer_row .nav-item.show .nav-link.active {
  background-color: #e3b5bb !important;
  color: white !important;
}

#crm_component .nav-link {
  border-color: #e3b5bb !important;
  color: #e3b5bb !important;
}
#crm_component .nav-link.active {
  background-color: #e3b5bb !important;
  color: white !important;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #crm_component .general_search {
    float: none;
    float: initial;
  }
}
#crm_component .general_search .box-label {
  display: inline-block;
  margin-bottom: 5px;
}
#crm_component .general_search .box-bg-input {
  display: inline-block;
  background-color: transparent;
  padding: 5px 5px;
  border-radius: 5px;
  box-shadow: none;
  border: 1px solid #e3b5bb;
  max-height: 30px;
}
#crm_component .general_search .box-bg-input:focus {
  border-color: #e3b5bb !important;
}
#crm_component .general_search .box-bg {
  display: inline-block;
  background-color: transparent;
  padding: 5px 5px;
  border-radius: 5px;
  box-shadow: none;
  border: 1px solid #e3b5bb;
  max-height: 31px;
  border-right: 0px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
#crm_component .general_search .box-bg:focus {
  border-color: #e3b5bb !important;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #crm_component .general_search .sheetType_selection {
    margin-left: 0;
  }
}
#crm_component .general_search .sheetType_selection .box-label {
  display: inline-block;
  margin-bottom: 5px;
}
#crm_component .general_search .sheetType_selection .select-box {
  display: inline-block;
  background-color: #f4f4f4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #f4f4f4;
  margin-left: 10px;
}
#crm_component .general_search .input-group-append .input-group-text {
  padding: 7px 5px;
  background: transparent;
  border: 1px solid #e3b5bb;
  border-left: 0px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
#crm_component .infinite-scroll-component {
  overflow-y: auto !important;
}
#crm_component .infinite-scroll-component::-webkit-scrollbar {
  display: none;
}
#crm_component table {
  /*table-layout: fixed;*/
  width: 100%;
}
#crm_component table th {
  vertical-align: baseline;
}
#crm_component table th .custom-from-check {
  min-height: auto;
  margin-bottom: 0;
}
#crm_component table tr.highlighted_row {
  background-color: #e3b5bb;
  color: #fff;
}
#crm_component table tr.highlighted_row td {
  color: #fff;
}
#crm_component table tr td {
  max-width: 120px;
  word-wrap: break-word;
}
#crm_component table tr td.addToMyList {
  width: 60px;
}
#crm_component table tr td.addToMyList .form-check-label {
  white-space: nowrap;
}
#crm_component input[type=checkbox] {
  width: 1em !important;
}
#crm_component .strong {
  font-weight: bold;
}
#crm_component .container_crm {
  padding: 0px 5px;
}
#crm_component .container_crm .list_and_information {
  font-size: 13px;
}
#crm_component .container_crm .list_and_information .header {
  width: 100%;
  margin-bottom: 10px;
}
#crm_component .container_crm .list_and_information .header .header_tools .total_items {
  display: inline-block;
}
#crm_component .container_crm .list_and_information .header .header_tools .total_items .box-label {
  display: block;
  margin-bottom: 5px;
}
#crm_component .container_crm .list_and_information .header .header_tools .total_items .box-bg {
  display: block;
  background-color: #f4f4f4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #f4f4f4;
}
#crm_component .container_crm .list_and_information .header .header_tools .generate_excel .btn {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  font-size: 16px;
  line-height: 15px;
  border: 1px solid #8ba6eb;
  background: #8ba6eb;
  margin-left: 15px;
  text-align: center;
  color: white;
  padding: 0px;
}
#crm_component .container_crm .list_and_information .row-sales-controls {
  justify-content: space-between;
  width: 100%;
  display: flex !important;
  flex-direction: row;
  float: none !important;
}
#crm_component .container_crm .list_and_information .customised-sales-controls {
  display: flex;
}
#crm_component .container_crm .list_and_information .add-new-tab {
  width: auto;
  width: initial;
  margin-right: 0px;
}
#crm_component .float-right {
  float: right;
}
#crm_component .list_and_information .add_new_customer {
  margin-left: 0px;
}
#crm_component .list_and_information .add_new_customer button {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  font-size: 16px;
  line-height: 15px;
  border: 1px solid #e3b5bb;
  background: #e3b5bb;
  margin-left: 15px;
  text-align: center;
  color: white;
  padding: 0px;
  display: inline-block;
}
#crm_component .list_and_information .advanced-search button {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  font-size: 16px;
  line-height: 15px;
  border: 1px solid #E3B5BB;
  background: #E3B5BB;
  margin-left: 15px;
  text-align: center;
  color: white;
  padding: 0px;
  display: inline-block;
}
#crm_component .list_and_information .merge-customer button {
  font-size: 14px;
  border: 1px solid #E3B5BB;
  background: #E3B5BB;
  text-align: center;
  color: white;
  padding: 5px;
  display: inline-block;
}
#crm_component .list_and_information .crm_list {
  width: 70%;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #crm_component .list_and_information .crm_list {
    width: 100%;
  }
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #crm_component .list_and_information .crm_list .col-left,
  #crm_component .list_and_information .crm_list .col-right {
    width: 100%;
  }
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #crm_component .list_and_information .crm_list .col-right {
    margin-top: 20px;
  }
}
#crm_component .list_and_information .crm_list .tab-pane {
  overflow: auto;
  width: 100%;
}
#crm_component .list_and_information .crm_list .tab-pane::-webkit-scrollbar {
  display: none;
}
#crm_component .list_and_information .crm_list table {
  font-size: 13px;
}
#crm_component .list_and_information .crm_list table thead {
  background-color: white;
  position: sticky;
  top: 0;
}
#crm_component .list_and_information .crm_list table thead tr.titles {
  border-style: hidden;
  background: #000000;
  color: white;
}
#crm_component .list_and_information .crm_list table thead tr.titles th {
  position: sticky;
  top: 0;
  vertical-align: baseline;
}
@media only screen and (max-width: 1760px) {
  #crm_component .list_and_information .crm_list table thead tr.titles th {
    font-size: 10px;
  }
}
@media only screen and (max-width: 1280px) {
  #crm_component .list_and_information .crm_list table thead tr.titles th {
    font-size: 9px;
  }
}
#crm_component .list_and_information .crm_list table thead tr.titles .saleDate,
#crm_component .list_and_information .crm_list table thead tr.titles .dateCustomerNeedsBy,
#crm_component .list_and_information .crm_list table thead tr.titles .dateReceivedInBackOffice,
#crm_component .list_and_information .crm_list table thead tr.titles .dueDate,
#crm_component .list_and_information .crm_list table thead tr.titles .addToMyList {
  cursor: pointer;
}
#crm_component .list_and_information .crm_list table thead tr.titles .created {
  cursor: pointer;
  width: 120px;
  align-items: center;
  align-content: center;
}
#crm_component .list_and_information .crm_list table thead tr.filters th {
  gap: 10px;
}
#crm_component .list_and_information .crm_list table thead tr.filters th input {
  width: 100%;
  border: 1px solid #d2d2d2;
  border-radius: 3px;
}
#crm_component .list_and_information .crm_list table thead tr.filters th.saleDate input {
  width: 95px;
}
#crm_component .list_and_information .crm_list table tbody tr {
  cursor: pointer;
}

#search_sales table {
  font-size: 13px;
}
#search_sales table thead {
  background-color: white;
  position: sticky;
  top: 0;
}
#search_sales table thead tr.titles {
  border-style: hidden;
  background: #000000;
  color: white;
}
#search_sales table thead tr.titles th {
  position: sticky;
  top: 0;
  vertical-align: baseline;
}
@media only screen and (max-width: 1760px) {
  #search_sales table thead tr.titles th {
    font-size: 10px;
  }
}
@media only screen and (max-width: 1280px) {
  #search_sales table thead tr.titles th {
    font-size: 9px;
  }
}
#search_sales table thead tr.titles .saleDate,
#search_sales table thead tr.titles .dateCustomerNeedsBy,
#search_sales table thead tr.titles .created,
#search_sales table thead tr.titles .dateReceivedInBackOffice,
#search_sales table thead tr.titles .dueDate,
#search_sales table thead tr.titles .addToMyList {
  cursor: pointer;
}
#search_sales table thead tr.filters th {
  gap: 10px;
}
#search_sales table thead tr.filters th input {
  width: 100%;
  border: 1px solid #d2d2d2;
  border-radius: 3px;
}
#search_sales table thead tr.filters th.saleDate input {
  width: 95px;
}
#search_sales table tbody tr {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/css/appointments/appointments.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;AADF;;AAKE;EACE,oCAAA;EACA,gCAAA;EACA,uBAAA;AAFJ;;AAOE;EACE,6BAAA;AAJJ;AAMI;EACE,mBAAA;AAJN;AAUI;;EACE,yBAAA;EACA,gCAAA;AAPN;AASM;;EACE,oCAAA;EACA,uBAAA;AANR;;AAaE;EACE,gCAAA;EACA,yBAAA;AAVJ;AAYE;EACE,oCAAA;EACA,uBAAA;AAVJ;AAaI;EADF;IAEI,WAAA;IAAA,cAAA;EAVJ;AACF;AAYI;EACE,qBAAA;EACA,kBAAA;AAVN;AAaI;EACE,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAXN;AAaM;EACE,gCAAA;AAXR;AAeI;EACE,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,8BAAA;EACA,4BAAA;EACA,+BAAA;AAbN;AAeM;EACE,gCAAA;AAbR;AAkBM;EADF;IAEI,cAAA;EAfN;AACF;AAiBM;EACE,qBAAA;EACA,kBAAA;AAfR;AAkBM;EACE,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAhBR;AAqBM;EACE,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,2BAAA;EACA,8BAAA;AAnBR;AAwBE;EACE,2BAAA;AAtBJ;AAyBI;EACE,aAAA;AAvBN;AA2BE;EACE,uBAAA;EACA,WAAA;AAzBJ;AA2BI;EACE,wBAAA;AAzBN;AA2BM;EACE,gBAAA;EACA,gBAAA;AAzBR;AA8BM;EACE,yBAAA;EACA,WAAA;AA5BR;AA8BQ;EACE,WAAA;AA5BV;AAgCM;EACE,gBAAA;EACA,qBAAA;AA9BR;AAgCQ;EACE,WAAA;AA9BV;AAgCU;EACE,mBAAA;AA9BZ;AAqCE;EACE,qBAAA;AAnCJ;AAsCE;EACE,iBAAA;AApCJ;AA0CE;EACE,gBAAA;AAxCJ;AA0CI;EAEE,eA3Lc;AAkJpB;AA2CM;EACE,WAAA;EACA,mBAAA;AAzCR;AA4CU;EACE,qBAAA;AA1CZ;AA4CY;EACE,cAAA;EACA,kBAAA;AA1Cd;AA6CY;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AA3Cd;AAgDY;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AA9Cd;AAoDM;EACE,8BAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;AAlDR;AAqDM;EACE,aAAA;AAnDR;AAsDM;EACE,WAAA;EAAA,cAAA;EACA,iBAAA;AApDR;AAyDE;EACE,YAAA;AAvDJ;AA2DI;EACE,gBAAA;AAzDN;AA2DM;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;AAzDR;AA6DM;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;AA3DR;AAgEM;EACE,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;AA9DR;AAkEI;EACE,UAAA;AAhEN;AAkEM;EAHF;IAII,WAAA;EA/DN;AACF;AAmEQ;EAFF;;IAGI,WAAA;EA/DR;AACF;AAmEQ;EADF;IAEI,gBAAA;EAhER;AACF;AAmEM;EACE,cAAA;EACA,WAAA;AAjER;AAoEQ;EACE,aAAA;AAlEV;AAsEM;EACE,eA3UY;AAuQpB;AAsEQ;EACE,uBAAA;EACA,gBAAA;EACA,MAAA;AApEV;AAsEU;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AApEZ;AAsEY;EACE,gBAAA;EACA,MAAA;EACA,wBAAA;AApEd;AAsEc;EALF;IAMI,eAAA;EAnEd;AACF;AAqEc;EATF;IAUI,cAAA;EAlEd;AACF;AAqEY;;;;;EAKE,eAAA;AAnEd;AAsEY;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;AApEd;AAyEY;EACE,SAAA;AAvEd;AAyEc;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AAvEhB;AA2EgB;EACE,WAAA;AAzElB;AAiFU;EACE,eAAA;AA/EZ;;AAwFE;EACE,eApZgB;AA+TpB;AAuFI;EACE,uBAAA;EACA,gBAAA;EACA,MAAA;AArFN;AAuFM;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AArFR;AAuFQ;EACE,gBAAA;EACA,MAAA;EACA,wBAAA;AArFV;AAuFU;EALF;IAMI,eAAA;EApFV;AACF;AAsFU;EATF;IAUI,cAAA;EAnFV;AACF;AAsFQ;;;;;;EAME,eAAA;AApFV;AAyFQ;EACE,SAAA;AAvFV;AAyFU;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AAvFZ;AA2FY;EACE,WAAA;AAzFd;AAiGM;EACE,eAAA;AA/FR","sourcesContent":["$font_size_content: 13px;\n\n.crm-title {\n  position: relative;\n  display: inline-block;\n  align-self: center;\n  margin: 0;\n}\n\n.customer {\n  .list-group-item.active {\n    background-color: #e3b5bb !important;\n    border-color: #e3b5bb !important;\n    color: white !important;\n  }\n}\n\n.customer_row {\n  .row {\n    border-bottom: #ddd solid 1px;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .nav-tabs,\n  .nav-item.show {\n    .nav-link {\n      color: #e3b5bb !important;\n      border-color: #e3b5bb !important;\n\n      &.active {\n        background-color: #e3b5bb !important;\n        color: white !important;\n      }\n    }\n  }\n}\n\n#crm_component {\n  .nav-link {\n    border-color: #e3b5bb !important;\n    color: #e3b5bb !important;\n  }\n  .nav-link.active {\n    background-color: #e3b5bb !important;\n    color: white !important;\n  }\n  .general_search {\n    @media all and (min-width: 0px) and (max-width: 600px) {\n      float: unset;\n    }\n\n    .box-label {\n      display: inline-block;\n      margin-bottom: 5px;\n    }\n\n    .box-bg-input {\n      display: inline-block;\n      background-color: transparent;\n      padding: 5px 5px;\n      border-radius: 5px;\n      box-shadow: none;\n      border: 1px solid#e3b5bb;\n      max-height: 30px;\n\n      &:focus {\n        border-color: #e3b5bb !important;\n      }\n    }\n\n    .box-bg {\n      display: inline-block;\n      background-color: transparent;\n      padding: 5px 5px;\n      border-radius: 5px;\n      box-shadow: none;\n      border: 1px solid#e3b5bb;\n      max-height: 31px;\n      border-right: 0px;\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n      border-top-right-radius: 0px;\n      border-bottom-right-radius: 0px;\n\n      &:focus {\n        border-color: #e3b5bb !important;\n      }\n    }\n\n    .sheetType_selection {\n      @media all and (min-width: 0px) and (max-width: 600px) {\n        margin-left: 0;\n      }\n\n      .box-label {\n        display: inline-block;\n        margin-bottom: 5px;\n      }\n\n      .select-box {\n        display: inline-block;\n        background-color: #f4f4f4;\n        padding: 5px 5px;\n        border-radius: 5px;\n        border-color: #f4f4f4;\n        margin-left: 10px;\n      }\n    }\n\n    .input-group-append {\n      .input-group-text {\n        padding: 7px 5px;\n        background: transparent;\n        border: 1px solid#e3b5bb;\n        border-left: 0px;\n        border-top-left-radius: 0px;\n        border-bottom-left-radius: 0px;\n      }\n    }\n  }\n\n  .infinite-scroll-component {\n    overflow-y: auto !important;\n\n    // height: calc(100vh - 200px) !important;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  table {\n    /*table-layout: fixed;*/\n    width: 100%;\n\n    th {\n      vertical-align: baseline;\n\n      .custom-from-check {\n        min-height: auto;\n        margin-bottom: 0;\n      }\n    }\n\n    tr {\n      &.highlighted_row {\n        background-color: #e3b5bb;\n        color: #fff;\n\n        td {\n          color: #fff;\n        }\n      }\n\n      td {\n        max-width: 120px;\n        word-wrap: break-word;\n\n        &.addToMyList {\n          width: 60px;\n\n          .form-check-label {\n            white-space: nowrap;\n          }\n        }\n      }\n    }\n  }\n\n  input[type=\"checkbox\"] {\n    width: 1em !important;\n  }\n\n  .strong {\n    font-weight: bold;\n  }\n\n  // ------------------------\n  //GENERAL DESIGN\n  // ------------------------\n  .container_crm {\n    padding: 0px 5px;\n\n    .list_and_information {\n      // display: flex;\n      font-size: $font_size_content;\n\n      .header {\n        width: 100%;\n        margin-bottom: 10px;\n\n        .header_tools {\n          .total_items {\n            display: inline-block;\n\n            .box-label {\n              display: block;\n              margin-bottom: 5px;\n            }\n\n            .box-bg {\n              display: block;\n              background-color: #f4f4f4;\n              padding: 5px 5px;\n              border-radius: 5px;\n              border-color: #f4f4f4;\n            }\n          }\n\n          .generate_excel {\n            .btn {\n              height: 32px;\n              width: 32px;\n              border-radius: 50%;\n              font-size: 16px;\n              line-height: 15px;\n              border: 1px solid #8ba6eb;\n              background: #8ba6eb;\n              margin-left: 15px;\n              text-align: center;\n              color: white;\n              padding: 0px;\n            }\n          }\n        }\n      }\n\n      .row-sales-controls {\n        justify-content: space-between;\n        width: 100%;\n        display: flex !important;\n        flex-direction: row;\n        float: none !important;\n      }\n\n      .customised-sales-controls {\n        display: flex;\n      }\n\n      .add-new-tab {\n        width: unset;\n        margin-right: 0px;\n      }\n    }\n  }\n\n  .float-right {\n    float: right;\n  }\n\n  .list_and_information {\n    .add_new_customer {\n      margin-left: 0px;\n\n      button {\n        height: 30px;\n        width: 30px;\n        border-radius: 50%;\n        font-size: 16px;\n        line-height: 15px;\n        border: 1px solid #e3b5bb;\n        background: #e3b5bb;\n        margin-left: 15px;\n        text-align: center;\n        color: white;\n        padding: 0px;\n        display: inline-block;\n      }\n    }\n    .advanced-search {\n      button {\n        height: 30px;\n        width: 30px;\n        border-radius: 50%;\n        font-size: 16px;\n        line-height: 15px;\n        border: 1px solid #E3B5BB;\n        background: #E3B5BB;\n        margin-left: 15px;\n        text-align: center;\n        color: white;\n        padding: 0px;\n        display: inline-block;\n      }\n    }\n\n    .merge-customer {\n      button {\n        font-size: 14px;\n        border: 1px solid #E3B5BB;\n        background: #E3B5BB;\n        text-align: center;\n        color: white;\n        padding: 5px;\n        display: inline-block;\n      }\n    }\n\n    .crm_list {\n      width: 70%;\n\n      @media all and (min-width: 0px) and (max-width: 600px) {\n        width: 100%;\n      }\n\n      .col-left,\n      .col-right {\n        @media all and (min-width: 0px) and (max-width: 600px) {\n          width: 100%;\n        }\n      }\n\n      .col-right {\n        @media all and (min-width: 0px) and (max-width: 600px) {\n          margin-top: 20px;\n        }\n      }\n\n      .tab-pane {\n        overflow: auto;\n        width: 100%;\n\n        // height: calc(100vh - 200px) !important;\n        &::-webkit-scrollbar {\n          display: none;\n        }\n      }\n\n      table {\n        font-size: $font_size_content;\n\n        thead {\n          background-color: white;\n          position: sticky;\n          top: 0;\n\n          tr.titles {\n            border-style: hidden;\n            background: #000000;\n            color: white;\n\n            th {\n              position: sticky;\n              top: 0;\n              vertical-align: baseline;\n\n              @media only screen and (max-width: 1760px) {\n                font-size: 10px;\n              }\n\n              @media only screen and (max-width: 1280px) {\n                font-size: 9px;\n              }\n            }\n\n            .saleDate,\n            .dateCustomerNeedsBy,\n            .dateReceivedInBackOffice,\n            .dueDate,\n            .addToMyList {\n              cursor: pointer;\n            }\n\n            .created {\n              cursor: pointer;\n              width: 120px;\n              align-items: center;\n              align-content: center;\n            }\n          }\n\n          tr.filters {\n            th {\n              gap: 10px;\n\n              input {\n                width: 100%;\n                border: 1px solid #d2d2d2;\n                border-radius: 3px;\n              }\n\n              &.saleDate {\n                input {\n                  width: 95px;\n                }\n              }\n            }\n          }\n        }\n\n        tbody {\n          tr {\n            cursor: pointer;\n          }\n        }\n      }\n    }\n  }\n}\n\n#search_sales {\n  table {\n    font-size: $font_size_content;\n\n    thead {\n      background-color: white;\n      position: sticky;\n      top: 0;\n\n      tr.titles {\n        border-style: hidden;\n        background: #000000;\n        color: white;\n\n        th {\n          position: sticky;\n          top: 0;\n          vertical-align: baseline;\n\n          @media only screen and (max-width: 1760px) {\n            font-size: 10px;\n          }\n\n          @media only screen and (max-width: 1280px) {\n            font-size: 9px;\n          }\n        }\n\n        .saleDate,\n        .dateCustomerNeedsBy,\n        .created,\n        .dateReceivedInBackOffice,\n        .dueDate,\n        .addToMyList {\n          cursor: pointer;\n        }\n      }\n\n      tr.filters {\n        th {\n          gap: 10px;\n\n          input {\n            width: 100%;\n            border: 1px solid #d2d2d2;\n            border-radius: 3px;\n          }\n\n          &.saleDate {\n            input {\n              width: 95px;\n            }\n          }\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        cursor: pointer;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
